import { useState, useEffect } from "react";

export function usePersistedState<T = any>(
  key: string,
  defaultValue?: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState(() => {
    const value = localStorage.getItem(key);
    if (typeof value === "string") {
      try {
        return JSON.parse(value as string);
      } catch (ex) {
        console.log("error while parsing JSON from local storage", ex);
      }
    }
    return defaultValue;
  });
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return [state, setState];
}
